// extracted by mini-css-extract-plugin
export var resourceHubPost = "styles-module--resourceHubPost--AqM4i";
export var placeholder = "styles-module--placeholder--zi8tr";
export var cta = "styles-module--cta--oOUss";